class LayoutTemplateFolderModalController extends AbstractController
	@register()
	@inject 'folder',
		'isImageUploadAllowed'

	onImageChange: (file, url) ->
		@image = {url, file}
